
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { modalSecondaryButtonStyle } from '../styles/buttonStyles'

const appStoreIcon = require('../assets/images/icons/app_store.png')
const googlePlayIcon = require('../assets/images/icons/google_play.png')

const APP_STORE_COUNTRIES = {
  sk: 'sk',
  en: 'gb',
  hu: 'hu',
  cs: 'cz',
  pl: 'pl',
  de: 'de',
  ua: 'ua',
  fr: 'fr',
  es: 'es',
  et: 'ee'
}

const AppDownloadModal = ({ open, onClose }) => {
  const { t, i18n } = useTranslation()

  const [hoverBtn, setHoverBtn] = useState(null)
  const [pressedBtn, setPressedBtn] = useState(null)

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        if (open) {
          onClose()
        }
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [open, onClose])

  useEffect(() => {
    if (!open) {
      setHoverBtn(null)
      setPressedBtn(null)
    }
  }, [open])

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.4)',
        display: open ? 'flex' : 'none',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#ededed',
          padding: 20,
          border: '1px solid #107c6b',
          borderRadius: 12,
          boxShadow: '0 12px 28px rgba(0,0,0,0.65)',
          width: 'clamp(320px, 30vw, 420px)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <h3 style={{ fontSize: 28, margin: 0, marginBottom: 24 }}>
          {t('DOWNLOAD_APP')}
        </h3>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 20,
            width: '100%',
            alignItems: 'center',
            marginBottom: 24
          }}
        >
          <img
            src={appStoreIcon}
            alt="App Store"
            onClick={() =>
              window.open(
                `https://apps.apple.com/${APP_STORE_COUNTRIES[i18n.language?.split('-')[0]] || 'sk'}/app/enerqiq-net/id6808968661`,
                '_blank',
                'noopener,noreferrer'
              )
            }
            onMouseEnter={() => setHoverBtn('appstore')}
            onMouseLeave={() => {
              setHoverBtn(null)
              setPressedBtn(null)
            }}
            onMouseDown={() => setPressedBtn('appstore')}
            onMouseUp={() => setPressedBtn(null)}
            style={{
              width: 220,
              height: 65,
              objectFit: 'contain',
              cursor: 'pointer',
              boxShadow:
                pressedBtn === 'appstore'
                  ? 'inset 0 3px 8px rgba(0,0,0,0.3)'
                  : '0 6px 10px rgba(0,0,0,0.7)',
              transform:
                pressedBtn === 'appstore'
                  ? 'scale(0.96)'
                  : 'scale(1)',
              transition: 'transform 0.08s ease, box-shadow 0.08s ease',
              borderRadius: 8
            }}
          />

          <img
            src={googlePlayIcon}
            alt="Google Play"
            onClick={() =>
              window.open(
                'https://play.google.com/store/apps/details?id=com.enerqiqmobile',
                '_blank',
                'noopener,noreferrer'
              )
            }
            onMouseEnter={() => setHoverBtn('googleplay')}
            onMouseLeave={() => {
              setHoverBtn(null)
              setPressedBtn(null)
            }}
            onMouseDown={() => setPressedBtn('googleplay')}
            onMouseUp={() => setPressedBtn(null)}
            style={{
              width: 220,
              height: 65,
              objectFit: 'contain',
              cursor: 'pointer',
              boxShadow:
                pressedBtn === 'googleplay'
                  ? 'inset 0 3px 8px rgba(0,0,0,0.3)'
                  : '0 6px 10px rgba(0,0,0,0.7)',
              transform:
                pressedBtn === 'googleplay'
                  ? 'scale(0.96)'
                  : 'scale(1)',
              transition: 'transform 0.08s ease, box-shadow 0.08s ease',
              borderRadius: 8
            }}
          />
        </div>

        <button
          style={modalSecondaryButtonStyle(
            pressedBtn,
            'close',
            hoverBtn === 'close'
          )}
          onMouseEnter={() => setHoverBtn('close')}
          onMouseLeave={() => {
            setHoverBtn(null)
            setPressedBtn(null)
          }}
          onMouseDown={() => setPressedBtn('close')}
          onMouseUp={() => setPressedBtn(null)}
          onClick={onClose}
        >
          {t('CLOSE')}
        </button>
      </div>
    </div>
  )
}

export default AppDownloadModal
